<template>
  <a :href="channel.url"
     :class="[
       'bx-epg-channel',
       { 'bx-epg-channel--detail': inHeader } ]">
    <figure v-if="channelLogoUrl">
      <img :src="channelLogoUrl"
           :alt="channel.logo.imageAltText"
           :title="channel.logo.imageAltText"
           :width="channel.logo.width"
           :height="channel.logo.height"
           loading="lazy">
    </figure>
    <span>{{ channel.name }}</span>
  </a>
</template>

<script>
import { mapState } from 'pinia'

import { useConfigStore } from '../../../../stores/config'
import { usePageStore } from '../../../../stores/page'
import { useImgSrcSet } from '../../../../composables/use-img-src-set'

export default {
  components: {

  },
  props: {
    channel: {
      type: Object,
      default: () => {}
    },
    inHeader: {
      type: Boolean,
      default: false
    }
  },
  setup () { return useImgSrcSet() },
  computed: {
    // this store prop is only used by a mixin
    ...mapState(useConfigStore, ['rsConfig']),
    ...mapState(usePageStore, ['brandFromStore']),
    channelLogoUrl () {
      return this.channel?.logo
        ? this.createImgSrc({
          image: this.channel.logo,
          brand: this.brandFromStore,
          type: 'webp',
          setName: 'channelLogo'
        })
        : null
    }
  }
}
</script>
